import api from 'service/api'

const dponetAPI = api.create('cookies', false)

const manage = async ({ bannerId, ageGateTextsOverrides }) =>
  await dponetAPI.post(
    `/banners/${bannerId}/age_gate/age_gate_texts_overrides`,
    {
      ageGateTextsOverrides,
    },
  )

export default {
  manage,
}
